import { render } from "./CreateMedicalInsurance.vue?vue&type=template&id=00b51730&scoped=true"
import script from "./CreateMedicalInsurance.vue?vue&type=script&lang=js"
export * from "./CreateMedicalInsurance.vue?vue&type=script&lang=js"

import "./CreateMedicalInsurance.vue?vue&type=style&index=0&id=00b51730&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00b51730"]])

export default __exports__